import React from 'react';
import Rail from './Rail';
import ContextBar from './ContextBar';
import SubNav from './SubNav';
import CommandPalette from './CommandPalette';
import IncomingCallPop from './IncomingCallPop';
import { ChatProvider } from '../context/ChatContext';
import ChatModal from '../pages/chat/ChatModal';
import './cmdk.css';

// Fixed layout: Rail on left, ContextBar across the top, optional SubNav
// under the context bar, main content fills the rest. Matches tokens.css grid.
// ⌘K command palette mounts once and overlays from anywhere.
// Incoming-call screen-pop is inert until the logged-in operator has an
// extension configured AND the PBX SSE stream emits an 'inbound' event.

const AppShell = ({ children }) => (
  <ChatProvider>
    <div className="app">
      <Rail />
      <ContextBar />
      <SubNav />
      <div className="main">
        {children}
      </div>
      <CommandPalette />
      <IncomingCallPop />
      <ChatModal />
    </div>
  </ChatProvider>
);

export default AppShell;
